import { render, staticRenderFns } from "./CreateDrawerBtn.vue?vue&type=template&id=33c9a832"
import script from "./CreateDrawerBtn.vue?vue&type=script&lang=js"
export * from "./CreateDrawerBtn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports